// @ts-expect-error - TS2614 - Module '"src/api-parsers"' has no exported member 'AudienceMember'. Did you mean to use 'import AudienceMember from "src/api-parsers"' instead?
import type {AudienceMember} from 'src/api-parsers';
import type {ReceiveAudienceMembersAction} from 'src/action-creators/group-audience';
import type {PersonRelatedSummary} from 'src/types/entity-summaries';

import get from 'lodash/get';

import {
  RECEIVE,
  RECEIVE_ME_GROUP_AUDIENCE_PAGE,
} from 'src/action-creators/group-audience';


export type State = {
  [groupId: string]: {
    memberListPages: {
      [page: string]: AudienceMember[];
    };
    numTotalMembers: number;
    numPages: number;
    candidateListPages: {
      [key: string]: PersonRelatedSummary[];
    };
  };
};

const initialState = Object.freeze({});

export default (
  state: State = initialState,
  action: ReceiveAudienceMembersAction,
): State => {
  switch (action.type) {
    case RECEIVE:
      const memberListPages = get(
        state,
        [action.payload.securityGroupId, 'memberListPages'],
        {},
      );

      // @ts-expect-error - TS2322 - Type '{ [x: string]: { memberListPages: { [page: string]: AudienceMember[]; }; numTotalMembers: number; numPages: number; candidateListPages: { [key: string]: PersonRelatedSummary[]; }; } | { ...; }; }' is not assignable to type 'State'.
      return {
        ...state,
        [action.payload.securityGroupId]: {
          numTotalMembers: action.payload.numTotalMembers,
          numPages: action.payload.numPages,
          memberListPages: {
            ...memberListPages,
            [String(action.payload.page)]: action.payload.memberList,
          },
        },
      };

    // @ts-expect-error - TS2678 - Type '"audienceMembers/me/receiveGroupPage"' is not comparable to type '"group-audience/receive"'.
    case RECEIVE_ME_GROUP_AUDIENCE_PAGE:
      const candidateListPages = get(
        state,
        // @ts-expect-error - TS2339 - Property 'groupId' does not exist on type 'AudienceMembersPayload'.
        [action.payload.groupId, 'candidateListPages'],
        {},
      );

      return {
        ...state,
        // @ts-expect-error - TS2339 - Property 'groupId' does not exist on type 'AudienceMembersPayload'.
        [action.payload.groupId]: {
          // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'AudienceMembersPayload'.
          numTotalMembers: action.payload.data.totalEntities,
          // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'AudienceMembersPayload'.
          numPages: action.payload.data.numPages,
          candidateListPages: {
            ...candidateListPages,
            // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'AudienceMembersPayload'.
            [String(action.payload.page)]: action.payload.data.entities,
          },
        },
      };
  }

  return state;
};
